import React, {useEffect, useState} from "react";
import {
    TextField,
    Button,
    CircularProgress,
    IconButton,
    InputAdornment,
    OutlinedInput,
    InputLabel,
    FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Autocomplete, Select, Typography, MenuItem, Checkbox,
} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {setSuccess} from "../../../Redux/AlertReducer";
import {useDispatch} from "react-redux";
import {Helper} from "../../../tools/Helper";
import {api_Routes} from "../../../tools/api_Routes";
import {Visibility, VisibilityOff} from "@mui/icons-material";
import {errorToaster} from "../../../helper/toasterConfiguration";

export const FormAddMembership = ({
                                      services,
                                      isServicesLoading,
                                  }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [selectedService, setSelectedService] = useState([]);
    const itemsPerPage = 25;
    const [servicesPage, setServicesPage] = useState(1);
    const [serviceSearchQuery, setServiceSearchQuery] = useState("");
    const paginatedServices = services.slice(0, servicesPage * itemsPerPage);
    const filteredServices = services.filter((service) =>
        service.title.toLowerCase().includes(serviceSearchQuery.toLowerCase())
    );
    const displayedServices = serviceSearchQuery
        ? filteredServices
        : paginatedServices;

    const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const [data, setData] = useState({
        name: "",
        description: "",
        level: 0,
        is_active: true,
        monthly_price: 0,
        discount_type: 0,
        discount: 0,
        price_per_item: 0,
        allow_multiple_months: false,
        services: []
    });

    const handleServiceChange = (event, newValue) => {
        setSelectedService(newValue);
        // Extract only service IDs
        const serviceIds = newValue.map(service => service.id);
        setData(prev => ({ ...prev, services: serviceIds }));
    };


    // Handle input changes
    const handleInputChange = (e) => {
        const {name, value} = e.target;
        setData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoadingSubmit(true);

        const formDataToSend = new FormData();

        formDataToSend.append('name', data.name);
        formDataToSend.append('description', data.description);
        formDataToSend.append('level', data.level);
        formDataToSend.append('is_active', data.is_active ? 1 : 0);
        formDataToSend.append('allow_multiple_months', data.allow_multiple_months ? 1 : 0);
        formDataToSend.append('monthly_price', data.monthly_price);
        formDataToSend.append('price_per_item', data.price_per_item);
        formDataToSend.append('discount', data.discount);
        formDataToSend.append('discount_type', data.discount_type);


        data.services.forEach(serviceId => {
            formDataToSend.append('services[]', serviceId);
        });

        try {
            const {result, response, message} = await Helper.Post({
                url: api_Routes.Membership.Add,
                data: formDataToSend,
                isFormData: true,
                showErrors: ["name", "monthly_price"],
            });

            setIsLoadingSubmit(false);
            if (response) {
                dispatch(setSuccess(true));
                navigate("/Membership");
            }
        } catch (error) {
            console.error("An error occurred during form submission:", error);
            setIsLoadingSubmit(false);
        }
    };


    return (
        <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-4">

                <TextField
                    fullWidth
                    margin="normal"
                    label="Name"
                    name="name"
                    required
                    type="name"
                    autoComplete="off"
                    value={data.name}
                    onChange={handleInputChange}
                    variant="outlined"
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="Monthly Price"
                    name="monthly_price"
                    required
                    type="number"
                    autoComplete="off"
                    value={data.monthly_price}
                    onChange={handleInputChange}
                    variant="outlined"
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="Price Per Item"
                    name="price_per_item"
                    required
                    type="number"
                    autoComplete="off"
                    value={data.price_per_item}
                    onChange={handleInputChange}
                    variant="outlined"
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="Discount"
                    name="discount"
                    type={'number'}
                    required
                    autoComplete="off"
                    value={data?.discount}
                    onChange={handleInputChange}
                    variant="outlined"

                />
                <FormControl className="w-full">
                    <InputLabel id="discount-type-select-label">
                        Discount Type
                    </InputLabel>
                    <Select
                        labelId="discount-type-select-label"
                        id="discount-type-select"
                        value={data.discount_type || null}
                        onChange={(e) => {
                            setData((prev) => ({
                                ...prev,
                                ["discount_type"]: e.target.value,
                            }));
                        }}
                        label="Discount Type"
                        sx={{ textAlign: "start" }}
                    >
                        <MenuItem value="none">None</MenuItem>
                        <MenuItem value="const">Constant</MenuItem>
                        <MenuItem value="percentage">Percentage</MenuItem>
                    </Select>
                </FormControl>
                <div className="w-full">
                    <Autocomplete
                        multiple
                        disablePortal
                        loading={isServicesLoading}
                        options={displayedServices}
                        getOptionLabel={(option) => option.title || ""}
                        onChange={handleServiceChange}
                        onInputChange={(event, value) => setServiceSearchQuery(value)}
                        renderInput={(params) => (
                            <TextField {...params} label="Service" variant="outlined"/>
                        )}
                        ListboxProps={{
                            onScroll: (event) => {
                                const listboxNode = event.currentTarget;
                                if (
                                    listboxNode.scrollTop + listboxNode.clientHeight >=
                                    listboxNode.scrollHeight - 3
                                ) {
                                    setServicesPage((prevPage) => prevPage + 1);
                                }
                            },
                        }}
                    />
                </div>
                <TextField
                    fullWidth
                    margin="normal"
                    label="Description"
                    name="description"
                    required
                    type="description"
                    multiline  // This enables textarea
                    rows={2}   // Default number of visible rows
                    autoComplete="off"
                    value={data.description}
                    onChange={handleInputChange}
                    variant="outlined"
                />
                <div className="w-full flex items-center justify-start gap-x-3">
                    <FormLabel sx={{ fontWeight: "bold" }} component="legend">
                        Active:
                    </FormLabel>
                    <RadioGroup
                        name="is_active"
                        value={data.is_active.toString()}
                        onChange={(e) => {
                            const value = e.target.value === 'true';
                            setData(prev => ({ ...prev, is_active: value }));
                        }}
                        row
                    >
                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                        <FormControlLabel value="false" control={<Radio />} label="No" />
                    </RadioGroup>
                </div>
            </div>
            <div className="w-full flex items-center justify-start gap-x-3">
                <FormLabel sx={{ fontWeight: "bold" }} component="legend">
                    Allow Multiple Months :
                </FormLabel>
                <RadioGroup
                    name="allow_multiple_months"
                    value={data.allow_multiple_months.toString()}
                    onChange={(e) => {
                        const value = e.target.value === 'true';
                        setData(prev => ({ ...prev, allow_multiple_months: value }));
                    }}
                    row
                >
                    <FormControlLabel value="true" control={<Radio />} label="Yes" />
                    <FormControlLabel value="false" control={<Radio />} label="No" />
                </RadioGroup>
            </div>
            {errorMessage && (
                <div className="w-full text-start text-red-600">*{errorMessage}</div>
            )}

            <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={isLoadingSubmit || errorMessage}
                color="primary"
                sx={{
                    display: isLoadingSubmit ? "flex" : "block",
                    marginTop: 2,
                    width: "20%",
                    marginX: "auto",
                    fontWeight: "bold",
                    justifyContent: "center",
                }}
            >
                {isLoadingSubmit ? (
                    <CircularProgress size={24} color="primary"/>
                ) : (
                    "Submit"
                )}
            </Button>
        </form>
    );
};
